import { Box, Text, useToggle } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

import { ExplotableItem, ExplotableList } from 'modules/core/components/GroupingExplotable'

import type PaymentItem from 'modules/payroll_bundle/store/models/PaymentItem'

import { GroupProp } from 'modules/payroll_bundle/pages/ResultsAndPaymentsPage/PaymentsPage/GeneratePaymentsPage/Table/types'
import GroupBody from './GroupBody'

interface Props {
  groups: GroupProp[]
  checkable: boolean
  onSelectItem: (paymentItem: PaymentItem) => void
  selected: Set<number>
}

type GroupProps = Pick<Props, 'checkable' | 'selected' | 'onSelectItem'> & {
  group: GroupProp
}

const ExplotableGroup = ({ checkable, onSelectItem, selected, group }: GroupProps) => {
  const [open, toggle] = useToggle(true)

  return (
    <ExplotableItem
      key={group.name}
      bottomRadius={false}
      dropDownAnimated={false}
      expandIcon="caret"
      headerBorders={false}
      headerRounded={false}
      opened={open}
      renderHeader={() => (
        <Box paddingLeft="s16">
          <Text.Normal size="200" weight="medium" color="grey800">
            {`${group.name} (${group.count})`}
          </Text.Normal>
        </Box>
      )}
      scrollLimited={false}
      size="small"
      toggle={toggle(!open)}
      type="primary"
    >
      <GroupBody
        items={group.paymentItem}
        checkable={checkable}
        onSelectItem={onSelectItem}
        selected={selected}
      />
    </ExplotableItem>
  )
}

const PaymentGroups = ({ groups, checkable, onSelectItem, selected }: Props) => {
  return (
    <ExplotableList>
      {groups.map((group) => {
        if (group.count > 0) {
          return (
            <ExplotableGroup
              key={group.name}
              group={group}
              checkable={checkable}
              onSelectItem={onSelectItem}
              selected={selected}
            />
          )
        }
      })}
    </ExplotableList>
  )
}

export default observer(PaymentGroups)
